module.exports = __webpack_public_path__ + "static/img/c1.968db6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c1.png
// module id = mSHj
// module chunks = 1